import { render, staticRenderFns } from "./PodcastEpisode.vue?vue&type=template&id=3a5617aa&scoped=true"
import script from "./PodcastEpisode.vue?vue&type=script&lang=js"
export * from "./PodcastEpisode.vue?vue&type=script&lang=js"
import style0 from "./PodcastEpisode.vue?vue&type=style&index=0&id=3a5617aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5617aa",
  null
  
)

export default component.exports